import {useMutation} from "@tanstack/react-query";
import {setBusinessUnitClaims} from "../services/ClaimService";

export function useSetBusinessUnitClaims() {
    return useMutation({
        mutationFn: setBusinessUnitClaims,
    });
}
